import { autoinject, bindable } from "aurelia-framework";
import { GridOptions } from "ag-grid";
import { HttpResponseMessage } from "aurelia-http-client";
import { I18N } from "aurelia-i18n";
import { Datasource, DatasourceFactory } from "../../services/datasource";
import { saveAs } from "file-saver";
import { AuthService } from "../../services/auth/auth-service";
import { DialogFactory } from "../../services/dialog-factory";
import { Geodata } from "./geodata";

@autoinject
export class Geometrie {
  @bindable() errorMessage?: string;

  gridOptions: GridOptions = {
    enableServerSideSorting: true,
    enableServerSideFilter: true,
    enableColResize: true,
    rowModelType: "infinite",
    paginationPageSize: 100,
    context: {
      // remember this view model, for later use in callbacks
      viewModel: this,
      deleteGeodata: this.deleteGeodata,
      previewGeodata: this.previewGeodata,
    },
  };

  private datasource: Datasource;

  constructor(
    datasourceFactory: DatasourceFactory,
    private dialogFactory: DialogFactory,
    private authService: AuthService,
    private i18n: I18N,
  ) {
    this.datasource = datasourceFactory.createDatasource("admin/geometrie");
    this.gridOptions.datasource =
      this.datasource.createGridDatasourceServerSideFiltering(undefined, [
        { colId: "file_name", sort: "asc" },
      ]);
  }

  onGridSizeChanged() {
    this.gridOptions.api!.sizeColumnsToFit();
  }

  /** note: this is called from an ag-grid callback */
  deleteGeodata(geodata: Geodata) {
    let self = (<any>this).viewModel; // hack to access "this" from an ag-grid callback
    self.askReallyDelete(geodata);
  }

  /** note: this is called from an ag-grid callback */
  previewGeodata(geodata: Geodata) {
    let self = (<any>this).viewModel; // hack to access "this" from an ag-grid callback
    self.previewData(geodata);
  }

  private previewData(geodata: Geodata) {
    this.datasource
      .downloadFile(geodata.id)
      .then((response) => {
        const blob = new Blob([response.response], {
          type: "application/octet-stream",
        });

        saveAs(blob, geodata.fileName);
      })
      .catch((e: HttpResponseMessage) => {
        console.log("ERROR", e);
        this.errorMessage =
          "unexpected error: " +
          e.statusCode +
          " " +
          e.statusText +
          (e.response ? ": " + e.response : "");
      });
  }

  private askReallyDelete(geodata: Geodata) {
    let message = this.i18n.tr("admin.geometrie.action.reallyDelete", {
      name: geodata.fileName,
    });
    this.dialogFactory.openOkCancel(message).then((confirmed) => {
      if (confirmed) {
        geodata.$status = "deleted";
        this.save(geodata);
      }
    });
  }

  private save(geodata: Geodata) {
    this.datasource
      .update([geodata])
      .then(() => {
        this.reload();
      })
      .catch((e: HttpResponseMessage) => {
        this.errorMessage =
          "unexpected error: " +
          e.statusCode +
          " " +
          e.statusText +
          (e.response ? ": " + e.response : "");
      });
  }

  private reload() {
    this.gridOptions.api!.purgeInfiniteCache();
    this.errorMessage = undefined;
  }
}
